import { motion } from "framer-motion";
import { DIRETTIVO, AVATARS } from "@/data/content";

export default function Direttivo() {
  return (
    <section id="direttivo" data-testid="direttivo-section" className="bg-secondary/40 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Il Direttivo</span>
          <h2 className="mt-3 font-display font-extrabold uppercase tracking-tight text-3xl md:text-4xl">
            Lo staff dell'Inter Club
          </h2>
          <p className="mt-4 text-muted-foreground font-medium">
            Le persone che ogni anno si impegnano per gestire al meglio il club e organizzare le attività riservate ai soci.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
          {DIRETTIVO.map((m, i) => {
            const src = m.foto || AVATARS[m.genere] || AVATARS.uomo;
            return (
              <motion.div
                key={i}
                data-testid="direttivo-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: (i % 4) * 0.08 }}
                className="group flex flex-col items-center text-center"
              >
                <div className="relative">
                  <div className="h-28 w-28 md:h-32 md:w-32 overflow-hidden rounded-full ring-4 ring-primary/20 shadow-lg group-hover:ring-gold/60 transition-all">
                    <img src={src} alt={m.nome} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                </div>
                <p className="mt-4 font-display font-bold text-lg leading-tight">{m.nome}</p>
                <span className="mt-1 inline-flex rounded-full bg-primary/10 text-primary px-3 py-1 text-xs font-bold uppercase tracking-widest">
                  {m.ruolo}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
